import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugalCompressorTurbineDriven = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 98,
	height: 67,
	viewBox: "0 0 98.0 67.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 64.5 2.0 L 87.5 2.0 L 87.5 0.0 L 98.0 4.5 L 87.5 9.0 L 87.5 7.0 L 69.5 7.0 L 69.5 26.0 L 64.5 25.0 Z M 24.5 17.0 L 74.5 27.0 L 74.5 57.0 L 24.5 67.0 Z M 19.5 32.0 L 19.5 52.0 L 0.5 47.0 L 0.5 37.0 Z M 0.0 2.0 L 39.5 2.0 L 39.5 20.0 L 34.5 19.0 L 34.5 7.0 L 0.0 7.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 19.5 39.0 L 24.5 39.0 M 19.5 45.0 L 24.5 45.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCentrifugalCompressorTurbineDriven;
